export default __webpack_public_path__ + "static/media/ico_plus_disabled.be6ede1b.svg";